import React from 'react';
import PropTypes from 'prop-types';

import styles from './LoadingSpinner.scss';

const LoadingSpinner = ({ showLoading, className = '', force = false }) => {
  return (
    <div
      className={`${styles.loadingBackground} ${className} ${
        showLoading || force ? styles.show : ''
      }`}
    >
      <div className={styles.loadingIcon} />
    </div>
  );
};

LoadingSpinner.propTypes = {
  showLoading: PropTypes.bool,
  className: PropTypes.string,
  force: PropTypes.bool,
};

export default LoadingSpinner;
